export class FollowedPage {
  Id: string;
  Path: string;
  Title: string;
  DriveId: string;
  Icon: string;
  ShowIcon: boolean;

  constructor(opt?: Partial<FollowedPage>) {
    Object.assign(this, opt);
  }
}
